import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from "utils/axios";
import { ROUTE_API } from 'configs';
import { dispatch } from 'store';
import { DefaultRootStateProps } from 'types';


const initialState: DefaultRootStateProps['ticketTypes'] = {
    listType: [],
    selectedStore: undefined,
    loading: false,
    error: null,
    isFetched: false,
};

const slice = createSlice({
    name: 'ticketTypes',
    initialState,
    reducers: {
        setListType: (state, action: any) => {
            state.listType = action.payload;
        },
        setIsFetched: (state, action: PayloadAction<boolean>) => {
            state.isFetched = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },

    },

});

export function getList() {
    return async () => {
        try {
            const params = {
                page: 1,
                perpage: 1000,
                // type
            };
            const response = await axios.get(ROUTE_API.ticket.getType, { params, headers: { isShowLoading: true } });
            const { Data } = response.data;
            dispatch(slice.actions.setListType(Data.data ?? []));
            dispatch(slice.actions.setIsFetched(true));
        } catch (error:any) {
            dispatch(slice.actions.setError(error?.message || 'Failed to fetch list.'));
        }finally {
            dispatch(slice.actions.setLoading(false));
        }

    };
}

export default slice.reducer;

